import { AxiosResponse } from 'axios'

// classes
import { http } from '../realisations/Http.realisation'

// types
import {
    CityPayloadT,
    CityResponseT,
    GetAllCitiesResponseT,
    GetCitiesBySenderResponseT,
    GetRegionsListResponseT,
    GetRegionsResponseT,
    GetZonesResponseT,
    RegionPayloadT,
    RegionResponseT,
    GetCityResponse,
    UpdateCityPayloadT,
} from '../types/cities.types'

export class CitiesRepository {
    getAllList(
        page: number,
        search?: string,
        limit?: number,
        regionId?: number,
        statusId?: number,
        postCode?: string
    ): Promise<AxiosResponse<GetAllCitiesResponseT>> {
        const params = {
            page,
            search,
            limit,
            regionId,
            statusId,
            postCode,
        }

        return http.get('/location/api/cities', { params })
    }

    getCity(city_id: number): Promise<AxiosResponse<GetCityResponse>> {
        return http.get(`/location/api/cities/${city_id}`)
    }

    getRegionsList(
        page: number,
        search?: string,
        limit?: number
    ): Promise<AxiosResponse<GetRegionsListResponseT>> {
        const params = {
            page,
            search,
            limit,
        }

        return http.get('/location/api/regions', { params })
    }

    getZonesList(page: number, search?: string): Promise<AxiosResponse<GetZonesResponseT>> {
        const params = {
            page,
            search,
        }

        return http.get('/cabinet/api/shipment-zones', { params })
    }

    getRegions(): Promise<AxiosResponse<GetRegionsResponseT>> {
        return http.get('/cabinet/api/city/create')
    }

    getCitiesBySender(sender_id: number): Promise<AxiosResponse<GetCitiesBySenderResponseT>> {
        return http.get(`/cabinet/api/direction/get_where_cities/${sender_id}`)
    }

    createCity(payload: CityPayloadT): Promise<AxiosResponse<CityResponseT>> {
        return http.post('/location/api/cities', payload)
    }

    updateCity(city_id: number, city_payload: UpdateCityPayloadT): Promise<AxiosResponse<CityResponseT>> {
        return http.put(`/location/api/cities/${city_id}`, city_payload)
    }

    deleteCity(city_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/location/api/cities/${city_id}`)
    }

    createRegion(payload: RegionPayloadT): Promise<AxiosResponse<RegionResponseT>> {
        return http.post('/location/api/regions', payload)
    }

    updateRegion(
        region_id: number,
        region_payload: RegionPayloadT
    ): Promise<AxiosResponse<RegionResponseT>> {
        return http.put(`/location/api/regions/${region_id}`, region_payload)
    }

    enableAvia(id: number): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/cities/${id}/avia/enable`, { id })
    }

    disableAvia(id: number): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/cities/${id}/avia/disable`, { id })
    }

    deleteRegion(region_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/location/api/regions/${region_id}`)
    }
}
